import { createMemoryHistory, createRouter } from 'vue-router'

// import StartHerePage from '@/views/StartHerePage'
import ConfiguratorPage from '@/views/ConfiguratorPage'

const routes = [
  // { path: '/', name: "StartHerePage", component: StartHerePage },
  // { path: '/configurator', name: "ConfiguratorPage", component: ConfiguratorPage }
  { path: '/', name: "ConfiguratorPage", component: ConfiguratorPage }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
})

export default router
